/* eslint-disable */
<template>
  <div>
    <div class="container-fluid w-100 no-padding">
      <div class="row bg-primary-dark">
        <div class="col-md-3">
          <h4>A1 Araç Görüntülemeleri</h4>
        </div>
        <div class="col-md-2 align-middle">
          <label for="filterPersonelId">İnceleyen Personel</label>
          <select class="form-control mr-2" id="filterPersonelId" v-model="filterPersonelId" @change="getA1Data()">
            <option value="0">Tüm personeller</option>
            <option value="3">Duygu Eşki</option>
            <option value="24">Hasan Cemre Ok</option>
            <option value="64">Ebru Karataş</option>
            <option value="71">Şaban Durdu</option>
            <option value="83">Tülin Supçin</option>
          </select>
        </div>
        <div class="col-md-2 align-middle">
          <label for="filterRetailerId">Bayii</label>
          <select @change="getA1Data()" class="form-control mr-2" id="filterRetailerId" v-model="selectedRetailerId">
            <option value="0">Bayii seçiniz...</option>
            <option value="1">LENOI</option>
            <option value="5">BÜLENT EŞKİ</option>
          </select>
        </div>
        <div class="col-md-2 align-middle">
          <label for="filterCustomerId">Müşteri</label>
          <cool-select v-model="selectedCustomer" id="filterCustomerId" :items="foundCustomers" :loading="customerSearching"
            disable-filtering-by-search  @select="onCustomerSelect"
            @search="onCustomerSearch" item-text="CUSTOMER_TITLE" placeholder="Müşteri...">
            <template slot="no-data">Müşteri bulunamadı</template>
            <div slot="item" class="search-slot-item" slot-scope="{ item }">
              <p class="text-truncate">{{item.CUSTOMER_TITLE}}</p>
              <small class="text-primary" >Müşteri Kodu : {{item.CUSTOMER_ID}}</small>
            </div>
          </cool-select>,
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="a1Data-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered table-striped table-hover">
              <thead class="thead-light">
                <tr>
                  <th style="width: 32px;" scope="col">#</th>
                  <th style="width: 35%;" scope="col">PERSONEL</th>
                  <th style="width: 35%;" scope="col">MÜŞTERİ / ARAÇ</th>
                  <th style="width: 10%;" scope="col">RAPOR TARİHİ</th>
                  <th style="width: 20%;" scope="col">VERİYE BAKILMA TARİHİ</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <template v-for="(a1rl, a1rlIndex) in a1Data">
                  <tr :key="'trow-first-' + a1rlIndex">
                    <td class="align-middle text-left">{{a1rlIndex + 1}}</td>
                    <td class="align-middle text-left">{{ a1rl.PERSONEL_NAME }}</td>
                    <td class="align-middle text-left">
                      <div class="justify-content-between">
                        <p class="my-0 text-primary font-semi-bold">{{ a1rl.VEHICLE_NAME }}</p>
                        <small>{{ a1rl.CUSTOMER_TITLE }}</small>
                      </div>
                    </td>
                    <td class="align-middle text-left">{{ formatDate(a1rl.REPORT_DATE) }}</td>
                    <td class="align-middle text-left">{{ formatDateTime(a1rl.ADDDATE) }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { CoolSelect } from 'vue-cool-select'

export default {
  name: 'A1ReportLogPage',
  components: {
    Datepicker,
    CoolSelect
  },
  data () {
    return {
      a1Data: [],
      filterPersonelId: 0,
      filterCustomerId: 0,
      selectedRetailerId: 0,
      foundCustomers: [],
      selectedCustomer: {},
      customerSearching: false
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    formatDateTime(dateTime) {
      return moment(dateTime).format('DD.MM.YYYY HH:mm')
    },
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY')
    },
    getA1Data() {
      this.$wait.start('a1Data-loading');

      axios
      .post('/api/a1/report-log', {
        filterPersonelId: parseInt(this.filterPersonelId),
        filterCustomerId: this.selectedCustomer.CUSTOMER_ID,
        filterRetailerId: parseInt(this.selectedRetailerId)
      })
      .then(response => {
        this.a1Data = response.data
        this.$wait.end('a1Data-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('a1Data-loading')
      })
    },
    async onCustomerSearch(query) {
      if(!query || query.length < 4) {
        this.foundCustomers = []
        this.customerSearching = false
        return
      }

      this.customerSearching = true

      let jsonReq = {}
      jsonReq.SessionId = this.getSessionId
      jsonReq.SearchFilter = query
      jsonReq.Retailer = this.selectedRetailerId
      await axios.post('/api/uruncikis/musteri-ara?sessionid=' + jsonReq.SessionId + 
        "&searchFilter=" + jsonReq.SearchFilter + "&retailer=" + jsonReq.Retailer, jsonReq)
      .then(response => {
        this.foundCustomers = response.data
        this.customerSearching = false
      })
      .catch(err => this.customerSearching = false)
      
    },
    async onCustomerSelect(item) {
      this.getA1Data()
    },
  },
  beforeMount() {
    moment.locale('tr')
  },
  mounted() {
    this.getA1Data()
  }
}
</script>

<style scoped>
  .font-semi-bold {
    font-weight: 700 !important;
  }

  .tabular-nums {
    -moz-font-feature-settings: "tnum";
    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum";
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.025em;
  }

  div.icon-global {
    position: absolute;
    z-index: 3;
    margin-left: -36px;
    margin-top: 24px;
    width: 30px;
    height: 30px;
    padding: 4px 4px 5px 4px;
    border-radius: 15px;
  }

  div.icon-global.bg-danger {
    margin-top: -6px !important;
  }

  div.icon-global i {
    color: #FFF;
  }

  .margin-negative {
    margin-bottom: -4px !important;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table { caption-side: top !important; }
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: 0.875rem;
  }

  td a.btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .text-truncated {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/A1ReportLogPage.vue